module.exports = __webpack_public_path__ + "c39f789b920045da66d77f028003a245.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/minus.png
// module id = 443
// module chunks = 0